module.exports = __webpack_public_path__ + "static/media/63.0effaf46.png";